import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';

ReactDOM.render(
	React.createElement(App),
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js